import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {Injectable} from '@angular/core';
import {PartnerModel} from '../../../api/model/partner.model';
import {PartnerConverter} from '../../../api/converter/partner.converter';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable({
    providedIn: 'root'
})
export class PartnerDataService extends AbstractDataServiceV2<PartnerModel, PartnerConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: PartnerConverter) {
        super('Partner', http, httpUrlGenerator, logger, config, converter);
    }
}
